import { Info } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import type { IntensitySuggestion as IntensitySuggestionType } from "@/hooks/use-staffing-requests";

interface Props {
  suggestion: IntensitySuggestionType;
}

export function IntensitySuggestion({ suggestion }: Props) {
  return (
    <Alert className="border-info-200 bg-info-50 text-info-800 dark:border-info-900/40 dark:bg-info-950/30 dark:text-info-300 [&>svg]:text-info-500">
      <Info />
      <AlertTitle>
        Suggested Intensity: {suggestion.intensity}
        <span className="ml-2 font-normal text-info-600 dark:text-info-400">
          based on {suggestion.basisHours.toLocaleString()} hrs over {suggestion.basisPeriod}
        </span>
      </AlertTitle>
      <AlertDescription className="text-[10px] text-info-600 dark:text-info-400/70">
        This is a suggestion only. Confirm or override in the Commit step — Intensity is never
        written without explicit confirmation.
      </AlertDescription>
    </Alert>
  );
}
